// extracted by mini-css-extract-plugin
export var category = "_kn-9";
export var categoryHeader = "_kn-e";
export var container = "_kn-0";
export var group = "_kn-a";
export var groupItems = "_kn-f";
export var groupSeparator = "_kn-j";
export var loading = "_kn-1";
export var noResults = "_kn-3";
export var placeholder = "_kn-2";
export var resultContent = "_kn-5";
export var resultIcon = "_kn-c";
export var resultItem = "_kn-g";
export var resultMeta = "_kn-8";
export var resultSubtitle = "_kn-7";
export var resultSuffix = "_kn-i";
export var resultTitle = "_kn-6";
export var resultsList = "_kn-4";
export var searchGroup = "_kn-d";
export var selected = "_kn-h";
export var subgroup = "_kn-b";